// import React from "react";
// import { Link } from "react-router-dom";

// function Breadcrump({ title, middle = "" }) {
//   return (
//     <section className="custom-breadcrumb">
//       <div className="container">

//         <div className="custom-breadcrumb-inner">

//           <h2 className="custom-breadcrumb-title">{title}</h2>

//           <div className="custom-breadcrumb-path">
//             <Link to="/">Home</Link>

//             {middle && (
//               <>
//                 <span>/</span>
//                 <Link to={`/${middle.toLowerCase()}`}>{middle}</Link>
//               </>
//             )}

//             <span>/</span>
//             <span className="active">{title}</span>
//           </div>

//         </div>

//       </div>
//     </section>
//   );
// }

// export default Breadcrump;








import React from "react";
import { Link } from "react-router-dom";

/* ------------------------------------------------------------------
   Signature background — a hand-repeated tile of whole-spice marks
------------------------------------------------------------------- */
function SpicePatternLayer() {
  return (
    <svg
      className="absolute inset-0 w-full h-full pointer-events-none"
      aria-hidden="true"
      style={{ opacity: 0.07 }}
    >
      <defs>
        <pattern id="spiceTile" width="72" height="72" patternUnits="userSpaceOnUse">
          {/* clove */}
          <path
            d="M10 8 Q13 2 16 8 Q13 16 10 8 Z"
            fill="var(--color-secondary)"
          />
          <line
            x1="13"
            y1="16"
            x2="13"
            y2="22"
            stroke="var(--color-secondary)"
            strokeWidth="1.2"
          />

          {/* star anise */}
          <g transform="translate(50,18)">
            {[0, 60, 120, 180, 240, 300].map((deg) => (
              <path
                key={deg}
                d="M0 0 L3 -8 L-3 -8 Z"
                fill="var(--color-primary)"
                transform={`rotate(${deg})`}
              />
            ))}
            <circle r="2.5" fill="var(--color-accent-gold)" />
          </g>

          {/* coriander */}
          <ellipse
            cx="24"
            cy="48"
            rx="3.5"
            ry="2.4"
            fill="var(--color-accent-gold)"
            transform="rotate(-20 24 48)"
          />
          <ellipse
            cx="30"
            cy="52"
            rx="3.5"
            ry="2.4"
            fill="var(--color-accent-gold)"
            transform="rotate(15 30 52)"
          />

          {/* peppercorns */}
          <circle cx="58" cy="55" r="2" fill="var(--color-secondary)" />
          <circle cx="64" cy="60" r="1.6" fill="var(--color-secondary)" />
          <circle cx="55" cy="62" r="1.4" fill="var(--color-secondary)" />
        </pattern>
      </defs>

      <rect width="100%" height="100%" fill="url(#spiceTile)" />
    </svg>
  );
}

function Breadcrump({ title, middle = "" }) {
  return (
    <section
      className="relative py-10 md:py-14 overflow-hidden border-b"
      style={{
        background:
          "linear-gradient(to bottom, var(--color-bg), var(--color-bg-alt))",
        borderColor: "var(--color-border)",
      }}
    >
      {/* Background Pattern */}
      <SpicePatternLayer />

      {/* Ambient Glow */}
      <div
        className="absolute top-1/2 left-[38%] -translate-x-1/2 -translate-y-1/2 w-[400px] h-[220px] rounded-full pointer-events-none animate-pulse"
        style={{
          background:
            "radial-gradient(closest-side, var(--color-accent-gold), transparent 70%)",
          opacity: 0.12,
          filter: "blur(70px)",
        }}
      />

      {/* Top Gold Line */}
      <div
        className="absolute top-0 left-1/2 -translate-x-1/2 w-20 h-[2px]"
        style={{
          background: "var(--color-accent-gold)",
          opacity: 0.5,
        }}
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="flex flex-col items-center text-center gap-2.5">

          {/* Small Label */}
          <span
            className="text-[10px] tracking-[0.3em] uppercase"
            style={{
              fontFamily: "var(--font-body)",
              color: "var(--color-accent-gold)",
            }}
          >
            ◆ Annvanta ◆
          </span>

          {/* Title */}
          <h2
            className="text-3xl md:text-4xl tracking-wide"
            style={{
              fontFamily: "var(--font-heading)",
              color: "var(--color-text)",
              letterSpacing: "0.03em",
            }}
          >
            {title}
          </h2>

          {/* Breadcrumb */}
          <div
            className="flex items-center justify-center gap-2 text-[13px] px-4 py-2 rounded-[var(--radius-full)] border"
            style={{
              fontFamily: "var(--font-body)",
              color: "var(--color-text-muted)",
              background: "rgba(255,255,255,0.7)",
              backdropFilter: "blur(10px)",
              WebkitBackdropFilter: "blur(10px)",
              borderColor: "var(--color-border)",
              boxShadow: "var(--shadow-sm)",
            }}
          >
            <Link
              to="/"
              className="font-medium transition-all duration-300"
              style={{ color: "var(--color-text-muted)" }}
              onMouseOver={(e) =>
                (e.currentTarget.style.color = "var(--color-primary)")
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.color = "var(--color-text-muted)")
              }
            >
              Home
            </Link>

            {middle && (
              <>
                <span
                  style={{ color: "var(--color-tan)" }}
                  className="select-none"
                >
                  /
                </span>

                <Link
                  to={`/${middle.toLowerCase()}`}
                  className="font-medium transition-all duration-300"
                  style={{ color: "var(--color-text-muted)" }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.color = "var(--color-primary)")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.color =
                      "var(--color-text-muted)")
                  }
                >
                  {middle}
                </Link>
              </>
            )}

            <span
              style={{ color: "var(--color-tan)" }}
              className="select-none"
            >
              /
            </span>

            <span
              className="font-semibold tracking-wide px-2.5 py-0.5 rounded-[var(--radius-md)]"
              style={{
                color: "var(--color-primary)",
                background: "var(--color-tan-light)",
              }}
            >
              {title}
            </span>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Breadcrump;